import { Card, EmptyState, Spinner } from "../../shared/ui/index.js";
import { fmtDateTime } from "../../shared/format.js";
import { useEventGuests } from "./events.api.js";

export function GuestsPanel({ eventId }: { eventId: string }) {
  const { data, isLoading } = useEventGuests(eventId);
  const items = data?.items ?? [];
  const totalMedia = items.reduce((n, g) => n + g.total, 0);
  const contributors = items.filter((g) => g.total > 0).length;

  return (
    <Card>
      <div className="flex items-baseline justify-between">
        <h2 className="font-serif text-lg text-stone-900">Invités</h2>
        <span className="text-xs text-stone-400">
          {items.length} inscrit{items.length > 1 ? "s" : ""} · {contributors} contributeur
          {contributors > 1 ? "s" : ""} · {totalMedia} média{totalMedia > 1 ? "s" : ""}
        </span>
      </div>
      <p className="mt-1 text-sm text-stone-500">
        Inscrits (nom + email saisis sur l'écran d'accueil) et contributeurs, regroupés par email.
      </p>

      {isLoading ? (
        <div className="mt-4">
          <Spinner />
        </div>
      ) : items.length === 0 ? (
        <div className="mt-4">
          <EmptyState>Aucun invité inscrit pour l'instant.</EmptyState>
        </div>
      ) : (
        <ul className="mt-4 divide-y divide-stone-100">
          {items.map((g, i) => (
            <li key={g.email ?? `nil-${i}`} className="flex items-center justify-between gap-3 py-3">
              <div className="min-w-0">
                <p className="truncate font-medium text-stone-900">{g.name}</p>
                <p className="truncate text-xs text-stone-500">{g.email ?? "email inconnu"}</p>
                <p className="mt-0.5 text-[11px] text-stone-400">
                  {g.total > 0
                    ? `dernier envoi ${fmtDateTime(g.lastAt!)}`
                    : g.registeredAt
                      ? `inscrit ${fmtDateTime(g.registeredAt)} · rien envoyé`
                      : "rien envoyé"}
                </p>
              </div>
              <div className="shrink-0 text-right text-xs text-stone-600">
                {g.total > 0 ? (
                  <>
                    <span className="rounded-full bg-stone-100 px-2 py-0.5 font-medium">
                      {g.total}
                    </span>
                    <span className="mt-1 block text-stone-400">
                      {g.images} photo{g.images > 1 ? "s" : ""} · {g.videos} vidéo
                      {g.videos > 1 ? "s" : ""}
                    </span>
                  </>
                ) : (
                  <span className="rounded-full bg-stone-50 px-2 py-0.5 text-stone-400">
                    inscrit
                  </span>
                )}
              </div>
            </li>
          ))}
        </ul>
      )}
    </Card>
  );
}
